const control_measuresRouter = [
  {
      path: "control_measures",
      name: "control_measures",
      component: () => import("@/views/admin/control_measures"),
      default: true,
      meta: {
          model: "control_measures",
          // requiresAuth: true,
      },
  },
  {
    path: "reviews_control_measures",
    name: "control_measures_reviews",
    component: () => import("@/views/admin/control_measures"),
    default: true,
    meta: {
        model: "control_measures",
        // requiresAuth: true,
    },
},
  {
      path: "control_measures/add",
      name: "addControlMeasures",
      component: () => import("@/views/admin/control_measures/function"),
      default: true,
      meta: {
          model: "control_measures",
          // requiresAuth: true,
      },
  },
  {
      path: "control_measures/edit/:id",
      name: "editControlMeasures",
      component: () => import("@/views/admin/control_measures/function"),
      default: true,
      meta: {
          model: "control_measures",
          // requiresAuth: true,
      },
  },
  {
        path: "control_measures/history",
        name: "HistoryControlMeasures",
        component: () => import("@/views/admin/control_measures/history"),
        default: true,
        meta: {
            model: "history_control_measures",
            // requiresAuth: true,
        },
    }
]
export default control_measuresRouter;